export default __webpack_public_path__ + "static/media/image_Workspace_dark_blue.3ab2a37a.svg";